import OrderRiskBadge from "./OrderRiskBadge";
import OrderStatusBadge from "./OrderStatusBadge";
import {
  formatExactDate, formatMoney, formatPaymentSummary, formatRelativeUpdate,
} from "./orderWorkspaceFormatters";
import styles from "./OrdersWorkspace.module.css";

const plural = (count, one, many) => `${count} ${count === 1 ? one : many}`;

export default function OrderQueueCard({ order, selected, onSelect }) {
  const sources = order.order_sources || [];
  const itemCount = sources.reduce((sum, source) => sum + (source.order_items?.length || 0), 0);
  const relativeUpdate = formatRelativeUpdate(order.updated_at);

  return (
    <button
      type="button"
      className={`${styles.queueCard} ${selected ? styles.queueCardSelected : ""}`}
      aria-label={`Open order ${order.order_number}`}
      aria-pressed={selected}
      onClick={() => onSelect(order.id)}
    >
      <span className={styles.queueCardTop}>
        <strong className={styles.orderNumber}>{order.order_number}</strong>
      </span>
      <span className={styles.queueCustomer}>{order.customer_name || "Unknown customer"}</span>
      <span className={styles.queueCounts}>
        {plural(sources.length, "store", "stores")} · {plural(itemCount, "listing", "listings")}
      </span>
      <span className={styles.queueBadges} role="group" aria-label="Order status and risk">
        {order.status && <OrderStatusBadge status={order.status} />}
        <OrderRiskBadge order={order} />
        {Number(order.is_dummy) === 1 && <span className={styles.dummyBadge}>Dummy</span>}
      </span>
      <span className={styles.queueCardMeta}>
        <span>{formatPaymentSummary(order)}</span>
        <strong>{formatMoney(order.grand_total)}</strong>
      </span>
      {relativeUpdate && <span className={styles.queueTime} title={formatExactDate(order.updated_at)}>{relativeUpdate}</span>}
    </button>
  );
}
